import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEn from './locales/en/translation.json';
import translationVi from './locales/vi/translation.json';

const resources = {
  en: {
    translation: translationEn,
  },
  vi: {
    translation: translationVi,
  },
};

const DETECTION_OPTIONS = {
  order: ['localStorage', 'querystring', 'cookie'],
  caches: ['cookie'],
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    detection: DETECTION_OPTIONS,
    resources,
    // lng: 'vi',
    fallbackLng: 'en',
    // keySeparator: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
